import Vue from "vue";
import { extend, localize, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate";
import { required, email, min,max, numeric, min_value, max_value, digits, double, between, confirmed } from "vee-validate/dist/rules";
import isAfter from 'validator/lib/isAfter';
import isBefore from 'validator/lib/isBefore';
import isDecimal from 'validator/lib/isDecimal';
import isAlpha from 'validator/lib/isAlpha';
//import ar from "vee-validate/dist/locale/ar.json";
import en from "vee-validate/dist/locale/en.json";

extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("min_value", min_value);
extend("max_value", max_value);
extend("numeric", numeric);
extend("digits", digits);
extend("double", double);
extend("between", between);
extend("confirmed", confirmed);
extend("double", double);

const date_between = {
    validate: (value, { min, max }) => {
        //console.log("date_between");
        //console.log(min);
        //if (isDate(max)) {
        //    max = max.toString();
        //    console.log(max);
        //}
        console.log(typeof min);
        console.log(typeof max);

        var result = isBefore(value + '', max + '') && isAfter(value + '', min + '');
        console.log(result);
        return result;
    },
    params: ['min', 'max']
}
extend("date_between", date_between);

const decimal = {
    validate: (value, { force, digits }) => {
        return isDecimal(value + '', { force_decimal: force != undefined ? force : false, decimal_digits: digits != undefined ? digits : "1,2" })
    }
}
extend("decimal", decimal);

const alpha = {
    validate: (value, { locale }) => {
        locale = locale != undefined ? locale : "en-US";
        return isAlpha(value, locale);
    },
    props: ['locale']
}
extend("alpha", alpha);

const arrayRequired = {
    validate: (value) => {
        return value.length > 0
    }
}

extend("arrayRequired", arrayRequired);



const fileExtension = {
    validate: (value, { extensions }) => {
        if (extensions.includes(value.name.split('.').pop().toLowerCase()))
            return true;

        return false;
    },
    params: ['extensions']
}

extend('fileExtension', fileExtension);

const uniqunessCheck = {
    validate: (value, { remoteId, api, property }) => {
        if (!value || (property && !value[property])) {
            return true;
        }
        let _remoteId = remoteId == 'undefined' ? 0 : remoteId;
        let v = property != undefined ? value[property] : value;
        return Vue.axios.get(api, { params: { value: v, remoteId: _remoteId } })
            .then(response => {
                if (response.data.status == 1 && response.data.valid) {
                    return true;
                } else {
                    return false;
                }

            }).catch(err => {
                console.log(err);
                return false;
            })


    },
    params: ['remoteId', 'api', 'property']
}

extend('uniqueValue', uniqunessCheck);



setInteractionMode('onlyOnInput', (context) => {
    return {
        on: ['input']
    }
});

en.messages['uniqueValue'] = "This value you entered is already registered in the database";
en.messages['decimal'] = "This value is not valid, enter number in format x.x";

localize({
    en: {
        messages: en.messages,
        fields: {
            file: {
                fileSize: "This file size exceeds the allowed limit",
                fileExtension: "This file extension is not allowed",
            }
        }
    },
    ar: {
        messages: {
            "alpha": "{_field_} يجب ان يحتوي على حروف فقط",
            "alpha_num": "{_field_} قد يحتوي فقط على حروف وارقام",
            "alpha_dash": "{_field_} قد يحتوي على حروف او الرموز - و _",
            "alpha_spaces": "{_field_} قد يحتوي فقط على حروف ومسافات",
            "between": "قيمة {_field_} يجب ان تكون ما بين {min} و {max}",
            "confirmed": "{_field_} لا يماثل التأكيد",
            "digits": "{_field_} يجب ان تحتوي فقط على ارقام والا يزيد عددها عن {length} رقم",
            "dimensions": "{_field_} يجب ان تكون بمقاس {width} بكسل في {height} بكسل",
            "email": "{_field_} يجب ان يكون بريدا اليكتروني صحيح",
            "excluded": "الحقل {_field_} غير صحيح",
            "ext": "نوع ملف {_field_} غير صحيح",
            "image": "{_field_} يجب ان تكون صورة",
            "integer": "الحقل {_field_} يجب ان يكون عدداً صحيحاً",
            "length": "حقل {_field_} يجب الا يزيد عن {length}",
            "max_value": "قيمة الحقل {_field_} يجب ان تكون اصغر من {min} او تساويها",
            "max": "الحقل {_field_} يجب ان يحتوي على {length} حروف على الأكثر",
            "mimes": "نوع ملف {_field_} غير صحيح",
            "min_value": "قيمة الحقل {_field_} يجب ان تكون اكبر من {min} او تساويها",
            "min": "الحقل {_field_} يجب ان يحتوي على {length} حروف على الأقل",
            "numeric": "{_field_} يمكن ان يحتوي فقط على ارقام",
            "oneOf": "الحقل {_field_} يجب ان يكون قيمة صحيحة",
            "regex": "الحقل {_field_} غير صحيح",
            "required": "هذه الخانة مطلوبة",
            "required_if": "حقل {_field_} مطلو]ب",
            "size": "{_field_} يجب ان يكون اقل من {size} كيلوبايت",
            "fileSize": "حجم الملف المحدد يتجاوز المسموح به",
            "fileExtension": "نوع هذا الملف غير مسموح به",
            "uniqueValue": "القيمة المدخلة مسجلة مسبقاً"
        },
        names: {
            email: "البريد الاليكتروني",
            password: "كلمة السر"
        }
    }
});

let LOCALE = "en";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Object.defineProperty(Vue.prototype, "locale", {
    get() {
        return LOCALE;
    },
    set(val) {
        LOCALE = val;
        localize(val);
    }
});
